import { Component, ViewChild, AfterViewInit } from '@angular/core';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { Config } from '../../core/DefaultConfig';
import { ComplaintTypeAddEditDialogComponent } from './add-edit-dialog/complaint-type-add-edit-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DeleteDialogComponent } from '../../shared/delete-dialog/delete-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ComplaintType } from '../../core/models/complaint-type.model';
import { DeleteModel } from '../../core/models/dele.model';
import { MatGridListModule } from '@angular/material/grid-list';
import { TranslateModule } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppUrlConstants } from '../../core/constants/AppUrlConstants';
import { ApplicationDataService } from '../../core/services/application-data.service';
import { GenericCrudService } from '../../core/services/generic-crud.service';
import { AlertDialogComponent } from '../../shared/alert-dialog/alert-dialog.component';
import { AuthenticationService } from '../../core/services/authentication.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getCustomPaginatorIntl } from "../../shared/paginator.helper";

@Component({
  selector: 'app-complaint-type',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatTableModule, MatSortModule, MatPaginatorModule,
    MatCardModule, MatIconModule, MatButtonModule, MatGridListModule, TranslateModule],
  templateUrl: './complaint-type.component.html',
  styleUrls: ["./complaint-type.component.css"],
  providers: [
    { provide: MatPaginatorIntl, useValue: getCustomPaginatorIntl('Complainant types per page') }
  ],
})

export class ComplaintTypeComponent implements AfterViewInit {
  displayedColumns: string[] = ['sr', 'name', 'description', 'whatsappNameEnglish', 'whatsappNameUrdu', 'isPublic', 'action'];
  config = new Config();

  dataSource: MatTableDataSource<ComplaintType>;
  dataList: ComplaintType[] = [];
  deleteModel: DeleteModel = {
    title: "DROP_COMPLAINT_TYP_TITLE",
    message: "COMPLAINT_TYPE_DROP_MESSAGE",
    deleteButtonText: "DROP",
    cancelButtonText: "CALCEL"
  };

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(public dialog: MatDialog, private crudService: GenericCrudService,
    private authService: AuthenticationService) {
    this.dataSource = new MatTableDataSource();
    this.dataSource.sortingDataAccessor = (item, property) => {
      const value = item[property as keyof ComplaintType];
      return typeof value === 'string' ? value.toLowerCase() : value;
    };
  }


  ngOnInit() {}

  ngAfterViewInit() {
    this.getBySegment(this.authService.getUserSegment());
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  getBySegment(id: number) {
    this.crudService.getById(id, AppUrlConstants.COMPLAINT_CATEGORY_URL + AppUrlConstants.SEGMENT).subscribe({
      next: (res: any) => {
        this.dataSource = new MatTableDataSource(res?.data);
        this.dataSource.sortingDataAccessor = (item, property) => {
          const value = item[property as keyof ComplaintType];
          return typeof value === 'string' ? value.toLowerCase() : value;
        };
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }
  add() {
    const dialogRef = this.dialog.open(ComplaintTypeAddEditDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.dataSource = new MatTableDataSource(result);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }

    });
  }
  edit(updateRecord: any, rowNumber: number) {
    const dialogRef = this.dialog.open(ComplaintTypeAddEditDialogComponent, {
      data: updateRecord
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.dataSource = new MatTableDataSource(result);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }

    });
  }
  delete(deleteRecord: any, rowNumber: number) {

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: this.deleteModel
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.crudService.delete(deleteRecord?.complaintCategoryId, AppUrlConstants.COMPLAINT_CATEGORY_URL).subscribe({
          next: () => {
            this.getBySegment(this.authService.getUserSegment());
          },
          error: (e) => {
            if (e?.status == 409) {
              if (e?.error?.errors !== null) {
                for (const property in e.error.errors) {
                  this.openAlert(e.error.errors[property]);
                }
              } else {
                this.openAlert(e?.error?.message);
              }
            }
          }
        });
      }
    });

  }
  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: 'OK'
        }
      },
    });
  }
}
